import React, { useState } from 'react'
import Tabs, { TabPanel, TabTrigger, TabTriggerGroup } from '@zera-admin/tabs'
import { Column, Row } from '@zera-admin/page'
import Select, { SelectOptionProps } from '@zera-admin/select'
import { string } from '@zera-admin/helpers'

import { getFieldOptions } from 'bi-tool/visualizations/visualization/getters'

import * as Styled from './RedditDefinitions.styled'
import { RedditDefinitionsProps } from './types'
import { REDDIT_FIELDS } from './constants'

const RedditDefinitions: React.FunctionComponent<RedditDefinitionsProps> = ({
  fields,
  onChange,
  options,
}) => {
  const [fieldOptions, setFieldOptions] = useState<SelectOptionProps[]>(
    getFieldOptions(fields)
  )

  const handleChangeFieldInput = (value: string) => {
    const option = {
      label: value,
      value,
    }
    const index = fieldOptions.findIndex(
      (reference) => reference.value === parseInt(option.value)
    )
    let optionsInstance = [...fieldOptions]

    if (value && index === -1) {
      optionsInstance[0] = option
    } else {
      optionsInstance = getFieldOptions(fields)
    }

    setFieldOptions(optionsInstance)
  }

  const renderTabs = () => {
    return (
      <Tabs id="tabs">
        <TabTriggerGroup>
          <TabTrigger>Veri </TabTrigger>
        </TabTriggerGroup>
        <TabPanel>{renderDataTab()}</TabPanel>
      </Tabs>
    )
  }

  const renderDataTab = () => {
    const values = options?.fields || {}

    return REDDIT_FIELDS.map((redditField, index) => (
      <Row key={index} xs={{ direction: 'column' }}>
        <Column>
          <Select
            name={redditField.value}
            options={fieldOptions}
            onChange={(props) => {
              onChange({
                ...options,
                fields: {
                  ...options.fields,
                  [redditField.value]: (props as SelectOptionProps)
                    .value as string,
                },
              })
            }}
            onInputChange={handleChangeFieldInput}
            value={
              values[redditField.value]
                ? {
                    label: string.textify(values[redditField.value]),
                    value: values[redditField.value],
                  }
                : { label: '', value: '' }
            }
            label={redditField.label}
            placeholder="Seçim yapınız"
          />
        </Column>
      </Row>
    ))
  }

  return <Styled.RedditDefinitions>{renderTabs()}</Styled.RedditDefinitions>
}

export default RedditDefinitions
